const state = {
    items: [],
    formUid: undefined,
};

const mutations = {
    addItem(state, item) {
      /**
       * Добавляет новый элемент в массив временных данных
       * @param {*} item - Элемент для добавления
       */
        state.items.push(item)
    },
    updateItem(state, obj) {
      /**
       * Обновляет существующий элемент в массиве временных данных
       * @param {Object} obj - Объект с данными для обновления
       */
        state.items[obj.num] = obj.item
    },
    saveUid(state, uid) {
      /**
       * Сохраняет уникальный идентификатор формы
       * @param {string} uid - Уникальный идентификатор формы
       */
        state.formUid = uid
    },
    clearItems(state) {
      /**
       * Очищает все временные данные формы
       */
        state.items = []
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    // actions,
}
